import { useTranslation } from 'react-i18next';

import { COURSE, HOME } from 'constants/routingPath';
import useGetOfficialSiteURL from 'hooks/useGetOfficialSiteURL';

const getNamespace = ns => ({ ns });

const COMMON = 'common';
const NAVBAR = 'navbar';

export default function useGetPathList() {
  const getOfficialSiteURL = useGetOfficialSiteURL();
  const { t } = useTranslation([NAVBAR, COMMON]);

  const pathList = [
    {
      link: getOfficialSiteURL(HOME),
      label: t('common.breadcrumb.home', getNamespace(COMMON)),
    },
    {
      link: getOfficialSiteURL(COURSE),
      label: t('navbar.link.course', getNamespace(NAVBAR)),
    },
  ];

  return pathList;
}
